/**
 * Shiffa Custom Sticky Header Enhancements
 * Lightweight scroll-aware styling for header
 */

document.addEventListener('DOMContentLoaded', () => {
  const headerComponent = document.querySelector('header-component');
  if (!headerComponent) return;

  // Add subtle shadow on scroll — no padding changes to avoid layout shift
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    header-component.header--scrolled {
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2) !important;
    }
    header-component.header--scrolled .header__row--top {
      border-bottom-color: rgba(200, 167, 76, 0.4) !important;
    }
  `;
  document.head.appendChild(styleElement);

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    headerComponent.classList.toggle('header--scrolled', scrollTop > 50);
  }, { passive: true });
});
